exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".thnosearch {\n  width: 20% !important;\n  padding-bottom: 45px !important; }\n\n.thsearch {\n  width: 20%; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/sooweeseng/Documents/Ionic Apps/FoonYew2_Backend_ok_version/webapp/src/app/routes/restaurant/orders/view-order/view-order.component.scss
// module id = ../../../../../src/app/routes/restaurant/orders/view-order/view-order.component.scss
// module chunks = main